/* PAWLLI — Nouvelle ère (Claude 01/10) */
(function(){
  if(window.__pwx) return; window.__pwx=1;
  var d=document, de=d.documentElement; de.classList.add('pw-js');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vh=window.innerHeight;

  function fitGiant(){
    d.querySelectorAll('[data-pwx-fit]').forEach(function(el){
      var box=el.parentElement, inner=el.firstElementChild||el; el.style.fontSize='100px';
      var w=inner.getBoundingClientRect().width||1, target=box.clientWidth*(parseFloat(el.dataset.pwxFit)||0.98);
      var fs=100*target/w, mx=parseFloat(el.dataset.pwxMax); if(mx&&fs>mx) fs=mx;
      el.style.fontSize=fs+'px';
    });
  }

  function splitWords(){
    d.querySelectorAll('[data-pwx-words]').forEach(function(el){
      if(el.dataset.done) return; el.dataset.done=1;
      var out=[];
      Array.prototype.slice.call(el.childNodes).forEach(function(n){
        var acc=n.nodeType===1, txt=n.textContent;
        txt.split(/(\s+)/).forEach(function(t){
          if(!t) return;
          if(/^\s+$/.test(t)){out.push(d.createTextNode(' '));return;}
          var s=d.createElement('span'); s.className='w'+(acc?' acc':''); s.textContent=t; out.push(s);
        });
      });
      el.textContent=''; out.forEach(function(n){el.appendChild(n)});
    });
  }

  function countUp(el){
    if(el.dataset.done) return; el.dataset.done=1;
    var to=parseFloat(el.dataset.pwxCount), dec=(el.dataset.pwxCount.split('.')[1]||'').length, pre=el.dataset.pre||'', suf=el.dataset.suf||'';
    if(reduce){el.textContent=pre+to.toFixed(dec).replace('.',',')+suf;return;}
    var t0=null, dur=1600;
    function f(t){ if(!t0)t0=t; var p=Math.min(1,(t-t0)/dur), e=1-Math.pow(1-p,3);
      el.textContent=pre+(to*e).toFixed(dec).replace('.',',')+suf; if(p<1) requestAnimationFrame(f); }
    requestAnimationFrame(f);
  }

  function playSteps(el){
    if(el.dataset.played) return; el.dataset.played=1;
    var st=el.querySelectorAll('.pwx-step'), n=st.length; el.style.setProperty('--p',0);
    st.forEach(function(s,i){ setTimeout(function(){
      st.forEach(function(x){x.classList.remove('cur')}); s.classList.add('on'); s.classList.add('cur');
      el.style.setProperty('--p', n>1? i/(n-1) : 1);
    }, reduce?0:200+i*520); });
  }

  var io='IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); if(e.target.dataset.pwxCount) countUp(e.target); if(e.target.hasAttribute('data-pwx-steps')) playSteps(e.target); io.unobserve(e.target);} });
  },{threshold:.15,rootMargin:'0px 0px -5% 0px'}) : null;

  function observe(){
    d.querySelectorAll('.pwx-rv,.pwx-pop,.pwx-giant,.pwx-card,[data-pwx-count],[data-pwx-steps]').forEach(function(el){
      if(el.dataset.obs) return; el.dataset.obs=1;
      if(io) io.observe(el); else { el.classList.add('is-in'); if(el.dataset.pwxCount) countUp(el); if(el.hasAttribute('data-pwx-steps')) playSteps(el); }
    });
  }

  var bar=null;
  function ensureBar(){ if(!d.querySelector('.pwx')||bar) return; bar=d.createElement('div'); bar.className='pwx-progress'; d.body.appendChild(bar); }

  var ticking=false;
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update);} }
  function update(){
    ticking=false; var y=window.scrollY||window.pageYOffset;
    if(bar){ var h=de.scrollHeight-vh; bar.style.transform='scaleX('+(h>0?y/h:0)+')'; }
    if(reduce) { d.querySelectorAll('[data-pwx-words] .w,.pwx-scene').forEach(function(w){w.classList.add('on')}); d.querySelectorAll('[data-pwx-zoom]').forEach(function(z){z.style.setProperty('--z',1);z.classList.add('txt-on')}); return; }
    d.querySelectorAll('.pwx-hero').forEach(function(h){
      var r=h.getBoundingClientRect(); if(r.bottom<0) return; var s=Math.max(0,-r.top);
      var im=h.querySelector('.pwx-slides'); if(im) im.style.transform='translate3d(0,'+(s*-0.08)+'px,0)';
      var g=h.querySelector('.pwx-giant'); if(g) g.style.transform='scale('+(1-Math.min(s,500)/2200)+')';
    });
    d.querySelectorAll('[data-pwx-words]').forEach(function(el){
      var r=el.getBoundingClientRect(), ws=el.querySelectorAll('.w');
      var p=(vh*0.9-r.top)/(r.height+vh*0.12); p=Math.max(0,Math.min(1,p));
      var n=Math.round(p*ws.length); for(var i=0;i<ws.length;i++) ws[i].classList.toggle('on',i<n);
    });
    d.querySelectorAll('[data-pwx-zoom]').forEach(function(el){
      var r=el.getBoundingClientRect(); var p=(vh*0.35-r.top)/Math.max(1,r.height-vh*0.65); p=Math.max(0,Math.min(1,p));
      el.style.setProperty('--z',p.toFixed(3)); el.classList.toggle('txt-on',p>0.45);
    });
    d.querySelectorAll('[data-pwx-scn]').forEach(function(el){
      var r=el.getBoundingClientRect(), sc=el.querySelectorAll('.pwx-scene');
      var p=(vh*0.55-r.top)/Math.max(1,r.height-vh*0.1); p=Math.max(0,Math.min(1,p)); el.style.setProperty('--p',p);
      sc.forEach(function(s){ var b=s.getBoundingClientRect(); s.classList.toggle('on', b.top+b.height*0.35 < vh*0.7); });
    });
    d.querySelectorAll('.pwx-stack').forEach(function(st){
      var cs=st.querySelectorAll('.pwx-card');
      for(var i=0;i<cs.length;i++){
        var c=cs[i], nx=cs[i+1]; if(!nx||getComputedStyle(c).position!=='sticky'){c.style.transform='';c.style.filter='';continue;}
        var top=parseFloat(getComputedStyle(c).top)||0, nt=nx.getBoundingClientRect().top;
        var p=(vh-nt)/Math.max(1,(vh-top)); p=Math.max(0,Math.min(1,p));
        c.style.transform='scale('+(1-p*0.07)+')'; c.style.filter='brightness('+(1-p*0.18)+')';
      }
    });
  }


  /* --- mobile v2 : pastilles du hero en défilement automatique --- */
  var mqM=window.matchMedia?window.matchMedia('(max-width:989px)'):null;
  function floatsAuto(){
    if(!mqM||!mqM.matches||reduce) return;
    d.querySelectorAll('.pwx-floats').forEach(function(box){
      if(box.dataset.auto) return;
      var kids=[].slice.call(box.children); if(kids.length<2) return;
      box.dataset.auto=1;
      kids.forEach(function(k){ var c=k.cloneNode(true); c.classList.add('is-in'); c.setAttribute('aria-hidden','true'); c.setAttribute('tabindex','-1'); c.removeAttribute('data-shopify-editor-block'); box.appendChild(c); });
      box.classList.add('pwx-auto');
      var pos=0, hold=false, seen=true, timer=null, speed=0.45;
      function half(){ var f=kids[0], c=box.children[kids.length]; return (c&&f)?(c.offsetLeft-f.offsetLeft):box.scrollWidth/2; }
      function stop(){ hold=true; clearTimeout(timer); }
      function resume(){ clearTimeout(timer); timer=setTimeout(function(){ pos=box.scrollLeft; hold=false; },1800); }
      box.addEventListener('touchstart',stop,{passive:true}); box.addEventListener('touchend',resume,{passive:true}); box.addEventListener('touchcancel',resume,{passive:true});
      box.addEventListener('pointerdown',stop); box.addEventListener('pointerup',resume); box.addEventListener('pointerleave',function(){ if(hold) resume(); });
      box.addEventListener('scroll',function(){ if(hold){ var h=half(); if(h>0&&box.scrollLeft>=h) box.scrollLeft-=h; } },{passive:true});
      if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ seen=es[0].isIntersecting; }).observe(box); }
      (function loop(){
        if(!hold&&seen&&!d.hidden&&mqM.matches){ var h=half(); pos+=speed; if(h>0&&pos>=h) pos-=h; box.scrollLeft=pos; }
        requestAnimationFrame(loop);
      })();
    });
  }

  /* --- mobile v2 : cartes « collection » empilées au défilement --- */
  function stackMobile(){
    d.querySelectorAll('.pwx-stack').forEach(function(st){
      var on=!!(mqM&&mqM.matches&&!reduce&&window.CSS&&CSS.supports&&CSS.supports('position','sticky'));
      st.classList.toggle('pwx-stack--m',on);
      var cs=st.querySelectorAll('.pwx-card');
      for(var i=0;i<cs.length;i++){
        if(!on){ cs[i].style.top=''; continue; }
        var base=74+i*10, h=cs[i].offsetHeight;
        cs[i].style.top=Math.round(Math.min(base, vh-h-14))+'px';
      }
    });
  }
  /* --- mobile v2 : rangée de produits (onglets) qui avance toute seule --- */
  var mqS=window.matchMedia?window.matchMedia('(max-width:749px)'):null;
  function rowsAuto(){
    if(!mqS||reduce) return;
    d.querySelectorAll('.pw-tabs-sec .pw-row').forEach(function(row){
      if(row.dataset.auto) return; row.dataset.auto=1;
      var hold=false, seen=false, timer=null;
      function stop(){ hold=true; clearTimeout(timer); }
      function resume(){ clearTimeout(timer); timer=setTimeout(function(){ hold=false; },4000); }
      row.addEventListener('touchstart',stop,{passive:true}); row.addEventListener('touchend',resume,{passive:true}); row.addEventListener('touchcancel',resume,{passive:true});
      row.addEventListener('pointerdown',stop); row.addEventListener('pointerup',resume);
      row.addEventListener('focusin',stop); row.addEventListener('focusout',resume);
      if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ seen=es[0].isIntersecting; },{threshold:.5}).observe(row); } else { seen=true; }
      setInterval(function(){
        if(hold||!seen||d.hidden||!mqS.matches||!row.offsetParent) return;
        if(row.scrollWidth-row.clientWidth<10) return;
        var li=row.querySelector('li'); if(!li) return;
        var step=li.getBoundingClientRect().width+(parseFloat(getComputedStyle(row).columnGap)||12);
        if(row.scrollLeft+row.clientWidth>=row.scrollWidth-6) row.scrollTo({left:0,behavior:'smooth'});
        else row.scrollBy({left:step,behavior:'smooth'});
      },3200);
    });
  }

  /* --- menu mobile : marque, coup de cœur, bouton boutique, réassurance --- */
  function mnav(){
    var dr=d.getElementById('menu-drawer'); if(!dr||dr.dataset.pw) return; dr.dataset.pw=1;
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var t=dr.querySelector('.menu-drawer__title');
    if(t&&!t.textContent.trim()) t.innerHTML='BRILYA<small>Boutique animaux</small>';
    var navs=dr.querySelectorAll('.menu-drawer__navigation'), last=navs[navs.length-1]; if(!last) return;
    var ar='<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 10L10 2M4 2h6v6"/></svg>';
    var box=d.createElement('div'); box.className='pwx-mnav';
    box.innerHTML='<a class="pwx-mnav__cta" href="'+root+'collections/all">Voir toute la boutique '+ar+'</a>'
      +'<ul class="pwx-mnav__list" role="list">'
      +'<li><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 6h11v9H3zM14 9h4l3 3v3h-7zM7 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/></svg>Livraison offerte dès 34,99 €</li>'
      +'<li><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4"/></svg>30 jours pour changer d’avis</li>'
      +'<li><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M4 4h16v12H8l-4 4z"/></svg>Service client en français</li></ul>';
    last.insertAdjacentElement('afterend',box);
    if(!window.fetch) return;
    var h='limeuse-ongles-silencieuse-silent-groom-pro';
    fetch(root+'products/'+h+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){
      if(!p||!p.available) return;
      var img=p.featured_image?String(p.featured_image):''; if(img) img+=(img.indexOf('?')<0?'?':'&')+'width=240';
      var a=d.createElement('a'); a.className='pwx-mnav__card'; a.href=root+'products/'+p.handle;
      var name=String(p.title).split(' — ')[0];
      a.innerHTML=(img?'<img src="'+img+'" alt="" loading="lazy" width="76" height="76">':'')
        +'<span><span class="pwx-mnav__k">Notre coup de cœur</span><span class="pwx-mnav__t"></span><span class="pwx-mnav__p">'+(p.price/100).toFixed(2).replace('.',',')+' € <i>Voir</i></span></span>';
      a.querySelector('.pwx-mnav__t').textContent=name;
      box.insertBefore(a,box.firstChild);
    }).catch(function(){});
  }

  function mouse(){
    if(reduce||!window.matchMedia('(pointer:fine)').matches) return;
    d.querySelectorAll('.pwx-hero').forEach(function(h){
      if(h.dataset.m) return; h.dataset.m=1;
      h.addEventListener('mousemove',function(e){
        var r=h.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        h.querySelectorAll('[data-depth]').forEach(function(el){ var k=parseFloat(el.dataset.depth); el.style.transform='translate3d('+(x*k)+'px,'+(y*k)+'px,0)'; });
      });
    });
  }

  function slides(){
    d.querySelectorAll('[data-pwx-slides]').forEach(function(w){
      if(w.dataset.ok) return; w.dataset.ok=1;
      var ss=w.querySelectorAll('.pwx-slide'); if(ss.length<2) return;
      var arch=w.parentElement, t=arch.querySelector('.pwx-slidecap__t'), bar=arch.querySelector('.pwx-slidecap__bar i'), i=0, dur=4800;
      function run(){ if(!bar) return; bar.classList.remove('run'); void bar.offsetWidth; bar.style.setProperty('--dur',dur+'ms'); bar.classList.add('run'); }
      function go(){
        ss[i].classList.remove('on'); i=(i+1)%ss.length; ss[i].classList.add('on');
        if(t){ t.classList.add('out'); setTimeout(function(){ t.textContent=ss[i].dataset.cap||''; t.classList.remove('out'); },300); }
        run();
      }
      run(); if(!reduce) setInterval(function(){ if(!d.hidden) go(); },dur);
    });
  }

  function fancy(){
    if(reduce||!window.matchMedia('(pointer:fine)').matches||!d.querySelector('.pwx')) return;
    if(!d.querySelector('.pwx-cursor')){
      var c=d.createElement('div'); c.className='pwx-cursor'; d.body.appendChild(c);
      var mx=0,my=0,cx=0,cy=0;
      window.addEventListener('mousemove',function(e){ mx=e.clientX; my=e.clientY; c.classList.add('on');
        c.classList.toggle('big', !!(e.target.closest && e.target.closest('a,button,.pwx-float,.pwx-tile'))); });
      d.addEventListener('mouseleave',function(){ c.classList.remove('on'); });
      (function loop(){ cx+=(mx-cx)*.18; cy+=(my-cy)*.18; c.style.transform='translate3d('+cx+'px,'+cy+'px,0)'; requestAnimationFrame(loop); })();
    }
    d.querySelectorAll('.pwx-btn').forEach(function(b){
      if(b.dataset.mag) return; b.dataset.mag=1;
      b.addEventListener('mousemove',function(e){ var r=b.getBoundingClientRect(); b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.22)+'px,'+((e.clientY-r.top-r.height/2)*.35)+'px)'; });
      b.addEventListener('mouseleave',function(){ b.style.transform=''; });
    });
    d.querySelectorAll('.pwx-tile,.pwx-step').forEach(function(el){
      if(el.dataset.tilt) return; el.dataset.tilt=1; el.setAttribute('data-pwx-tilt','');
      el.addEventListener('mousemove',function(e){ var r=el.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        el.style.transform='perspective(900px) rotateY('+(x*6)+'deg) rotateX('+(-y*6)+'deg) translateY(-4px)'; });
      el.addEventListener('mouseleave',function(){ el.style.transform=''; });
    });
  }

  function nav(){
    var ul=d.querySelector('.header__inline-menu .list-menu--inline'); if(!ul||ul.dataset.pw) return; ul.dataset.pw=1;
    var pill=d.createElement('span'); pill.className='pwx-navpill'; ul.appendChild(pill);
    var links=[].slice.call(ul.querySelectorAll(':scope > li > a.header__menu-item, :scope > li > header-menu summary.header__menu-item, :scope > li > details summary.header__menu-item'));
    var cur=links.filter(function(a){return a.getAttribute('aria-current')==='page'||a.querySelector('.header__active-menu-item')})[0]||null;
    function to(a){ links.forEach(function(x){x.classList.toggle('pwx-on',x===a)}); if(!a){pill.classList.remove('on');return;}
      var ur=ul.getBoundingClientRect(), r=a.getBoundingClientRect(); pill.style.width=r.width+'px'; pill.style.transform='translateX('+(r.left-ur.left)+'px)'; pill.classList.add('on'); }
    links.forEach(function(a){ a.addEventListener('mouseenter',function(){to(a)}); a.addEventListener('focus',function(){to(a)}); });
    ul.addEventListener('mouseleave',function(){to(cur)});
    setTimeout(function(){to(cur)},120); window.addEventListener('resize',function(){to(cur)});
  }

  function cards(){
    var items=d.querySelectorAll('.product-grid > .grid__item, .pw-row > li, .collection-list > .grid__item');
    var cio='IntersectionObserver' in window ? new IntersectionObserver(function(es){
      var k=0; es.forEach(function(e){ if(e.isIntersecting){ var el=e.target; el.style.transitionDelay=(k++*70)+'ms'; el.classList.add('pwx-in'); cio.unobserve(el);} });
    },{threshold:.12}) : null;
    items.forEach(function(el){ if(el.dataset.cx) return; el.dataset.cx=1; if(!reduce&&cio){ el.classList.add('pwx-cardx'); cio.observe(el);} });
    d.querySelectorAll('.card-wrapper .card__media').forEach(function(m){ if(m.querySelector('.pwx-cardcta')) return; var s=d.createElement('span'); s.className='pwx-cardcta'; s.innerHTML='<i></i>Voir le produit'; m.appendChild(s); });
  }

  function pages(){
    window.addEventListener('pageshow',function(){ de.classList.remove('pwx-leaving'); });
    d.addEventListener('click',function(e){
      if(reduce||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
      var a=e.target.closest&&e.target.closest('a[href]'); if(!a||a.target||a.hasAttribute('download')) return;
      var u; try{u=new URL(a.href,location.href);}catch(x){return;}
      if(u.origin!==location.origin||u.hash&&u.pathname===location.pathname||/^\/(cart|checkout|account)/.test(u.pathname)) return;
      e.preventDefault(); de.classList.add('pwx-leaving'); setTimeout(function(){ location.href=u.href; },200);
    });
    window.addEventListener('scroll',function(){ de.classList.toggle('pwx-scrolled',(window.scrollY||0)>40); },{passive:true});
  }

  function init(){ nav(); mnav(); cards(); slides(); fancy(); splitWords(); fitGiant(); observe(); ensureBar(); mouse(); vh=window.innerHeight; floatsAuto(); rowsAuto(); stackMobile(); update();
    setTimeout(function(){ d.querySelectorAll('.pwx-hero .pwx-giant,.pwx-hero .pwx-arch,.pwx-hero .pwx-pop,.pwx-hero .pwx-rv').forEach(function(g){g.classList.add('is-in')}); },60); }
  pages();
  if(d.readyState!=='loading') init(); else d.addEventListener('DOMContentLoaded',init);
  window.addEventListener('load',fitGiant);
  if(d.fonts&&d.fonts.ready) d.fonts.ready.then(fitGiant);
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){vh=window.innerHeight;fitGiant();stackMobile();floatsAuto();onScroll();});
  window.addEventListener('load',function(){vh=window.innerHeight;stackMobile();onScroll();});
  d.addEventListener('shopify:section:load',init);
})();
